import { Select, SelectProps, SelectOption } from '@ets/design-system';

type ToolbarDropdownOption = SelectOption & {
  supported?: boolean;
  fontFamily?: string;
};
type ToolbarDropdownProps<
  T extends ToolbarDropdownOption,
  M extends boolean = false,
  C extends boolean = false,
> = Omit<SelectProps<T, M, C>, 'variant' | 'size'> & { width: string };

const ToolbarDropdown = <
  T extends ToolbarDropdownOption,
  M extends boolean = false,
  C extends boolean = false,
>({
  styles,
  width,
  isCreatable,
  disabled,
  ...props
}: ToolbarDropdownProps<T, M, C>) => {
  const newStyles: SelectProps<T, M, C>['styles'] = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '62rem',
      zIndex: 3,
    }),
    menuList: (provided) => ({
      ...provided,
      paddingTop: '1rem',
      maxHeight: '62rem',
    }),
    group: (provided) => ({
      ...provided,
      padding: '0',
    }),
    groupHeading: (provided) => ({
      ...provided,
      height: '3rem',
      lineHeight: '2rem',
      fontSize: '1.25rem',
      fontWeight: 500,
      color: '#9797A6',
      padding: 0,
      paddingLeft: '1rem',
      letterSpacing: '1px',
      margin: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      height: '5rem',
      fontFamily: state.data.fontFamily ? `"${state.data.fontFamily}"` : 'Inter',
    }),
  };

  return (
    <Select
      {...props}
      variant="ghost"
      size="m"
      disabled={disabled}
      width={`${width}rem`}
      isCreatable={isCreatable}
      styles={{ ...newStyles, ...styles }}
    />
  );
};

export default ToolbarDropdown;
